module.exports = __webpack_public_path__ + "static/media/CM.be53fc06.svg";